import DynamicImportScheduler from '@utils/browser/DynamicImportScheduler';

export const getMainTasks = shelves =>
  shelves
    ? [() => import('@shopDetails/components/ShopDetailsShelves/Loadable')]
    : [() => import('@shopDetails/components/ShopDetailsExtended/Loadable')];

const highTasks = [() => import('@productConfig/Loadable')];
const lowTasks = [
  () => import('@checkout/router/Loadable'),
  () => import('@shopDetails/pages/ShopInfo/Loadable'),
  () => import('@shopDetails/pages/Reviews/Loadable'),
];

function preloadShopDetailsRouter({ isShelvesMenuLayout = false } = {}) {
  const mediumTasks = [() => import('@cart/router/Loadable')];

  if (isShelvesMenuLayout) {
    mediumTasks.push(
      () => import('@shopDetails/pages/SectionDetails/Loadable'),
      () => import('@shopDetails/pages/MenuSearch/Loadable'),
      () => import('@shopDetails/pages/SectionDetailsFromSection/Loadable'),
    );
  }

  DynamicImportScheduler.preload({
    id: `shopDetailsRouter_shelves:${isShelvesMenuLayout}`,
    highTasks: [...getMainTasks(isShelvesMenuLayout), ...highTasks],
    mediumTasks,
    lowTasks,
  });
}

export default preloadShopDetailsRouter;
